"use client";

import ServiceTitle from "@/shared/app/ui/text/ServiceTitle";
import { motion } from "framer-motion";
import Image from "next/image";

export default function OverViewSection() {
  return (
    <div className="w-full xl:max-w-[1280px] mx-auto px-5 xl:px-2 py-14 md:py-16 xl:py-20">
      {/* 오버뷰 타이틀  */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
      >
        <div className="text-center flex flex-col justify-center items-center mb-20 md:mb-40">
          <span
            className="text-[#EC6C50] text-base md:text-2xl mb-8 sm:mb-10 md:mb-20 flex tracking-tight"
            style={{ fontFamily: '"paperlogy-bold", sans-serif' }}
          >
            overview
          </span>
          <p
            className="text-2xl sm:text-3xl md:text-5xl text-[#353535] leading-8  sm:leading-12 md:leading-16 text-center tracking-tight"
            style={{ fontFamily: '"paperlogy-Light", sans-serif' }}
          >
            약속 장소를 고를 때<br /> 무엇을{" "}
            <span style={{ fontFamily: '"paperlogy-bold", sans-serif' }}>
              먼저
            </span>{" "}
            확인하시나요?
          </p>
        </div>
      </motion.div>
      {/* 이미지 */}
      <motion.div
        className="relative w-full h-[300px] sm:h-[400px] md:h-[500px] xl:h-[640px]"
        initial={{ opacity: 0, y: 40, scale: 0.95 }}
        whileInView={{ opacity: 1, y: 0, scale: 1 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <Image
          src="/assets/images/page/service/weslo/overview.svg"
          alt="overview Image"
          fill
          className="object-contain object-center"
        />
      </motion.div>
      <div className="flex flex-col items-center justify-center text-center py-10 md:py-20">
        {/* 원형 3개 */}
        <motion.div
          className="flex flex-col items-center space-y-3 mb-6 md:mb-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={{
            hidden: {},
            visible: {
              transition: {
                staggerChildren: 0.2,
              },
            },
          }}
        >
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              className="w-2 h-2 md:w-[12px] md:h-[12px] rounded-full bg-[#5346B0]"
              variants={{
                hidden: { opacity: 0, y: -10 },
                visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
              }}
            />
          ))}
        </motion.div>

        {/* 텍스트 */}
        <motion.p
          className="text-xl sm:text-3xl md:text-5xl text-[#5346B0] leading-8 sm:leading-12 md:leading-16 tracking-tight"
          style={{ fontFamily: '"paperlogy-Light", sans-serif' }}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
          viewport={{ once: true, amount: 0.3 }}
        >
          이동약자에게는{" "}
          <span style={{ fontFamily: '"paperlogy-bold", sans-serif' }}>
            작은 문턱
          </span>
          과 <span>계단 한 칸</span>이
          <br />
          가장 큰 벽이 됩니다.
        </motion.p>
      </div>
    </div>
  );
}
